import { AppRecord } from "../types"

/** Filters apps by a given text input */
const filterAppsByText =
  (text?: string) =>
  (apps: AppRecord[]): AppRecord[] => {
    if (!text || text.length === 0) return apps

    const lowerCaseText = text.toLowerCase()

    return apps.filter((app) => app.label.toLowerCase().includes(lowerCaseText))
  }

export default filterAppsByText
